export class Controller {

    /** @ngInject */
    constructor($state, Alert, UsersResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    $onInit() {
        this.displayName = this.companyUser.displayName;
        this.selection = null;
    }

    notModified() {
        return !this.selection && this.displayName === this.companyUser.displayName;
    }

    save() {
        this.isSaving = true;
        this.UsersResource
            .editDisplayNameOfEmployee(this.companyId, this.companyUser.id, this.displayName)
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.user-directories.manage-user.edit-display-name.saved'))
            .finally(() => this.isSaving = false)
    }

    selectionChanged() {
        this.displayName = (this.selection || this.companyUser).displayName;
    }

    saveDisabled(form) {
        return form.$invalid || this.isSaving || this.notModified();
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/edit-display-name/edit-display-name.controller.js